var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1968_25452)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1968_25452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1968_25452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 18.9596C5.05573 18.9596 1.03906 14.943 1.03906 10.0013C1.03906 5.05964 5.05573 1.04297 9.9974 1.04297C14.9391 1.04297 18.9557 5.05964 18.9557 10.0013C18.9557 14.943 14.9391 18.9596 9.9974 18.9596ZM9.9974 2.29297C5.7474 2.29297 2.28906 5.7513 2.28906 10.0013C2.28906 14.2513 5.7474 17.7096 9.9974 17.7096C14.2474 17.7096 17.7057 14.2513 17.7057 10.0013C17.7057 5.7513 14.2474 2.29297 9.9974 2.29297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.087 13.2765C12.9786 13.2765 12.8703 13.2515 12.7703 13.1848L10.187 11.6431C9.54531 11.2598 9.07031 10.4181 9.07031 9.67646V6.25977C9.07031 5.9181 9.35365 5.63477 9.69531 5.63477C10.037 5.63477 10.3203 5.9181 10.3203 6.25977V9.67646C10.3203 9.97646 10.5703 10.4181 10.8286 10.5681L13.412 12.1098C13.712 12.2848 13.8036 12.6681 13.6286 12.9681C13.5036 13.1681 13.2953 13.2765 13.087 13.2765Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1968_25452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGrayIcon);
export default __webpack_public_path__ + "static/media/clock_gray_icon.8685b29571b9d8d499a242831b886454.svg";
export { ForwardRef as ReactComponent };